import { locale, store } from '../services/translator';
import { webServiceHost } from '../services/dior';

export const CART_CDC_COOKIE = 'cdc_cart_items_count';
export const CART_PCD_COOKIE = 'CartItemsCount';

export const CART_CDC_URLS = {
  development: `/fixtures/cart-cdc.json`,
  test: `/fixtures/cart-cdc.json`,
  preProduction : `${webServiceHost}/couture/ecommerce/checkout/cart/getjsoncartitems_V2?___store=${store}`,
  production: `${webServiceHost}/couture/ecommerce/checkout/cart/getjsoncartitems_V2?___store=${store}`
};

export const CART_PDC_URLS = {
  development: `/fixtures/cart-pcd.json`,
  test: `/fixtures/cart-pcd.json`,
  preProduction: `${webServiceHost}/beauty/${locale}/get-basket.json?cart=true`,
  production: `${webServiceHost}/beauty/${locale}/get-basket.json?cart=true`
};



// WEBPACK FOOTER //
// ./src/settings/cart.js